import { ospreyAPI } from '@repo/api/ospreyAPI'
import { storeWrapper } from '../storeWrapper'
import { throttle } from '@repo/utils/debounce'

const initialState = {
  laaCodes: []
}

export const useContractWorkFormStore = storeWrapper('useCustomWorkFormStore', (set) => ({
  ...initialState,
  fetchLaaCodes: async ({ activeDate, type, branchId, feeClass }) => {
    return new Promise((resolve, reject) => {
      throttle({
        id: `fetchLaaCodes-${activeDate}`,
        callback: async () => {
          try {
            const laaCodes = await ospreyAPI({
              service: 'matters',
              endpoint: 'LaaFeeCode/GetAllActive',
              data: { activeDate, branchId, feeClass }
            })

            laaCodes.forEach((code) => {
              code.value = code.laaFeeCodeId

              switch (type.toUpperCase()) {
                case 'CDSI':
                  code.apiPropertyName = 'investigationLaaFeeCodeId'
                  break
                case 'CDSPR':
                  code.apiPropertyName = 'proceedingLaaFeeCodeId'
                  break
                case 'CDSAR':
                  code.apiPropertyName = 'appealReviewLaaFeeCodeId'
                  break
                case 'CDSPL':
                  code.apiPropertyName = 'prisonLawLaaFeeCodeId'
                  break
              }
            })

            set({ laaCodes })
            resolve(laaCodes)
          } catch (err) {
            reject(err)
          }
        }
      })
    })
  },

  fetchCrmListItems: async ({ fieldId }) => {
    return new Promise((resolve, reject) => {
      throttle({
        id: `fetchCrmListItems-${fieldId}`,
        callback: async () => {
          try {
            const listItems = await ospreyAPI({
              service: 'matters',
              endpoint: 'CrmListItemValue/GetAllByFieldId',
              data: { fieldId }
            })

            resolve(listItems)
          } catch (err) {
            reject(err)
          }
        }
      })
    })
  },

  fetchCrmInvestigationProceeding: async ({ clientNo, matterNo }) => {
    if (!clientNo) return
    return new Promise((resolve, reject) => {
      throttle({
        id: `fetchCrmInvestigationProceeding-${clientNo}-${matterNo}`,
        callback: async () => {
          try {
            const data = await ospreyAPI({
              service: 'matters',
              endpoint: 'CrmInvestigationProceeding/Get',
              data: { ClientNo: clientNo, MatterNo: matterNo },
              suppress404: true
            })

            resolve(data)
          } catch (err) {
            reject(err)
          }
        }
      })
    })
  },

  saveCrmInvestigationProceeding: async ({ payload, method = 'PUT' }) => {
    if (!payload) return
    return new Promise((resolve, reject) => {
      throttle({
        id: `saveCrmInvestigationProceeding`,
        callback: async () => {
          try {
            await ospreyAPI({
              service: 'matters',
              endpoint: `CrmInvestigationProceeding/${method === 'PUT' ? 'Update' : 'Create'}`,
              data: payload,
              method,
              shouldTrimObjectStringValues: false,
              successToast: {
                type: 'success',
                title: 'Success',
                text: 'Contract Work Form saved successfully.'
              }
            })

            resolve()
          } catch (err) {
            reject(err)
          }
        }
      })
    })
  },

  fetchCrmPrisonLawAppealsReview: async ({ clientNo, matterNo }) => {
    if (!clientNo) return
    return new Promise((resolve, reject) => {
      throttle({
        id: `fetchCrmPrisonLawAppealsReview-${clientNo}-${matterNo}`,
        callback: async () => {
          try {
            const data = await ospreyAPI({
              service: 'matters',
              endpoint: 'CrmPrisonLawAppealsReview/Get',
              data: { ClientNo: clientNo, MatterNo: matterNo },
              suppress404: true
            })

            resolve(data)
          } catch (err) {
            reject(err)
          }
        }
      })
    })
  },

  saveCrmPrisonLawAppealsReview: async ({ payload, method = 'PUT' }) => {
    if (!payload) return
    return new Promise((resolve, reject) => {
      throttle({
        id: `saveCrmPrisonLawAppealsReview`,
        callback: async () => {
          try {
            await ospreyAPI({
              service: 'matters',
              endpoint: `CrmPrisonLawAppealsReview/${method === 'PUT' ? 'Update' : 'Create'}`,
              data: payload,
              method,
              shouldTrimObjectStringValues: false,
              successToast: {
                type: 'success',
                title: 'Success',
                text: 'Contract Work Form saved successfully.'
              }
            })

            resolve()
          } catch (err) {
            reject(err)
          }
        }
      })
    })
  },

  checkForExistingMaatId: async ({ clientNo, matterNo, proceedingMaatId }) => {
    return new Promise((resolve, reject) => {
      throttle({
        id: `checkForExistingMaatCodes-${clientNo}-${matterNo}`,
        callback: async () => {
          try {
            const data = await ospreyAPI({
              service: 'matters',
              endpoint: 'CrmInvestigationProceeding/ExistsByProceedingMaatId',
              data: { excludeClientNo: clientNo, excludeMatterNo: matterNo, proceedingMaatId }
            })

            resolve(data === true)
          } catch (err) {
            reject(err)
          }
        }
      })
    })
  },

  checkForExistingDsccNumber: async ({ clientNo, matterNo, investigationDsccNumber }) => {
    return new Promise((resolve, reject) => {
      throttle({
        id: `checkForExistingMaatId-${clientNo}-${matterNo}-${investigationDsccNumber}`,
        callback: async () => {
          try {
            const data = await ospreyAPI({
              service: 'matters',
              endpoint: '/CrmInvestigationProceeding/ExistsByInvestigationDsccNumber',
              data: { excludeClientNo: clientNo, excludeMatterNo: matterNo, investigationDsccNumber }
            })

            resolve(data === true)
          } catch (err) {
            reject(err)
          }
        }
      })
    })
  },

  reset: () => set(initialState)
}))
